import { Component } from 'react';

// Last line of defence for the contact form.
//
// React unmounts the entire tree on an unhandled render error, so a single bad
// prop inside the form white-screens every page on the site. That is exactly how
// an undefined reCAPTCHA sitekey took the site down. This boundary contains any
// such failure to the form itself and swaps in the static one instead.
//
// Note this catches errors thrown during render and in lifecycle methods. It
// does NOT catch errors inside event handlers or rejected promises -- the submit
// path handles those with its own try/catch.
class ContactFormBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error('[contact form] live form failed to render, using static form:', error);
  }

  render() {
    if (this.state.failed) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default ContactFormBoundary;
